import { USER_SEARCH, MY_ACCOUNT } from "../Navigation/RouteConstants";

// Checks env variables for truthiness in the case the variables are expecting true or false.
export const parseEnvBool = (envVar) => {
  const value = process.env[envVar]?.toLowerCase();
  return ['true', '1', 'yes', 'on', 'enabled'].includes(value);
};

export const getLoginUserDetails = ()=>{
   let username = localStorage.getItem("loginState")? JSON.parse(localStorage.getItem("loginState")):"";
   return (username && username.loginUserName?
    {loginUserName:username.loginUserName,loginUserID:username.logInUserId}:'');
}
export const scrollToElement = (ref, time = 10) => {
    if (ref) {
      setTimeout(() => {
        ref.current.scrollIntoView({ behavior: 'smooth' });
      }, time);
    }
  };
  
export const parseJwt = (token) => {
    var base64Url = token.split('.')[1];
    var base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
    var jsonPayload = decodeURIComponent(atob(base64).split('').map(function (c) {
      return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
    }).join(''));
    return JSON.parse(jsonPayload);
  };

export const safeLocalStorage = (actType, storeName, data) => {
    let res;
    try {
        if (actType === "set") {
            res = localStorage.setItem(storeName, data);
        } else if (actType === "get") {
            res = localStorage.getItem(storeName);
        } else if (actType === "remove") {
            res = localStorage.removeItem(storeName);
        }
    } catch {
        console.error("No access to local storage.");
    }
    return res;
};

const dataToUrlParam = rowData => {
  const objStr = JSON.stringify(rowData);
  const toBase64 = btoa(encodeURIComponent(objStr));
  return toBase64;
};

export const decodeParams = (encodedStr) => {
  const decodedStr = decodeURIComponent(atob(encodedStr));
  const paramsObj = JSON.parse(decodedStr);
  return paramsObj;
};

export const getQueryParam = (params, key) => {
  if (params instanceof URLSearchParams) {
    return params.get(key);
  }
  if (typeof params === 'object' && params !== null) {
    return params[key];
  }
  return null;
};


export const navigateToCMdSApp = (href, userName, accessToken, refreshToken, impStateLoginInd, normalUser, orgID, orgName, npiId) => {
  // Create an object to hold the query parameters
  let queryParams = {
    user: userName,
    accessToken: accessToken,
    refreshToken: refreshToken,
    impStateLoginInd: impStateLoginInd,
    normalUser: normalUser
  };
  if(href == USER_SEARCH){
    queryParams['isClicked'] = accessToken ? 'yes' : null
  }else if(href == process.env.REACT_APP_WP_URL && orgID){
    queryParams['orgID'] = orgID,
    queryParams['orgName'] = orgName,
    queryParams['npiId'] = npiId
  }else if(href == MY_ACCOUNT){
     queryParams['isClicked'] = accessToken ? 'yes' : null
     queryParams['show'] = 'HOME'
  }
  // Encode the query parameters using dataToUrlParam
  const encodedParams = dataToUrlParam(queryParams);
  // Construct the URL with encoded parameters
  const url = `${href}?encodedParams=${encodedParams}`;
  return url;
};
  